import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";

var ls = new SecureLS({ isCompression: false });

Vue.use(Vuex)

const state = {
    lang: 'pt',
    darkMode: false,
    token: null,
    loading: false,
    firstRequest: false,
    sendingRequest: false,
    routeBeforeLogin: '/',
    privacy: '',
    login: {
        remember: false,
        email: null,
        password: null,
    },
    user: {
        name: null,
        roles: null,
        ID: null,
    },
    offline: false,
    offlineCounter: 0,
    cancelInstall: false,
}

const mutations = {
    START(state) {
        state.loading = false;
        state.sendingRequest = false;
    },
    OFFLINE(state) {
        state.offline = true;
        state.offlineCounter++;
    },
    ONLINE(state) {
        state.offline = false;
        state.offlineCounter = 0;
    },
    CHANGE_PASSWORD(state, password) {
        if (state.login.remember) {
            state.login.password = password;
        }
    },
    SET_LOGIN(state, { response, email, password, remember }) {
        state.token = response.token;
        state.user.ID = response.ID;
        state.user.name = response.name;

        state.user.roles = response.roles;

        state.login.remember = remember;
        state.login.email = email;
        state.login.password = password;
    },
    CLEAR_LOGIN(state) {
        state.token = null;
        state.user.ID = null;
        state.user.name = null;

        state.user.roles = null;

        state.login.remember = false;
        state.login.email = null;
        state.login.password = null;
    },
    LOADING(state, loading) {
        state.loading = loading;
    },
    SENDING_REQUEST(state, sendingRequest) {
        state.sendingRequest = sendingRequest;
    },
    FIRST_REQUEST(state, firstRequest) {
        state.firstRequest = firstRequest;
    },
    SET_LANG(state, lang) {
        state.lang = lang;
    },
    SET_DARK_MODE(state, darkMode) {
        state.darkMode = darkMode;
    },
}

const getters = {
    getLang: state => String(state.lang),
    isOffline: state => Boolean(state.offline),
    isDarkMode: state => Boolean(state.darkMode),
    isLogged: state => Boolean(state.token),
    isLoading: state => Boolean(state.loading),
    isSendingRequest: state => Boolean(state.sendingRequest),
    isFirstRequest: state => Boolean(state.firstRequest),
    verifyRole: (state) => (role) => Boolean(state.token && state.user && state.user.roles.includes(role)),
}

export default new Vuex.Store({
    plugins: [
        createPersistedState({
            storage: {
                getItem: (key) => ls.get(key),
                setItem: (key, value) => ls.set(key, value),
                removeItem: (key) => ls.remove(key),
            },
        }),],
    state,
    getters,
    mutations
})